import { configureStore } from '@reduxjs/toolkit';
import filterReducer from "../Reducers/filterReducer"
import galleryReducer from "../Reducers/galleryReducer"
import channelReducer from '../Reducers/channelReducer'

const store = configureStore({
    reducer: {
        filter: filterReducer,
        gallery: galleryReducer,
        channel: channelReducer
    }
});

export default store;